
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';
import { KeySelectItem } from '@core/models/select-item.model';


@Component({
    selector: 'form-field-fill-multiple-choice-v1',
    templateUrl: './fill-multiple-choice-v1.component.html'
})
export class FillMultipleChoiceV1FieldComponent implements OnInit {
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Choose some option/s";
    public form: FormGroup =  new FormGroup({});
    public selectedValues: Array<string> = [];
    public valid: boolean = false;

    ngOnInit(): void {
        this.emitValidity();
        if(this.fieldSubmission.field.options?.values)
            this.init();
    }

    init(){
        // we dont need to prepare items to view on checkboxes
        // if there are values set they are already checked on isChecked method.
        // we need to check the validity on load
        if(this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.length > 0){
            this.selectedValues = this.fieldSubmission.serialized_value;
            this.valid = true;
            this.emitValidity();
        }
    }

    isChecked(value: string) : boolean {
        return this.selectedValues ? this.selectedValues.some((fval) => fval === value) : false;
    }

    onCheckedChange(option: string, checked: boolean) {
        let updatedValues = [...this.selectedValues];
        if (checked) {
            // Add the option if it is not already in the array
            if (!updatedValues.includes(option)) {
                updatedValues.push(option);
            }
        } else {
            // Remove the option if it is in the array
            updatedValues = updatedValues.filter(value => value !== option);
        }
        this.selectedValues = updatedValues;
        this.valid = (this.selectedValues.length > 0 || !this.fieldSubmission.field.mandatory);
        // console.log(" Multiple Choice onSelect => ",option);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias,  value: this.selectedValues});
        this.emitValidity();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
